<template>
  <modalWindow v-if="logging" @close="logging=false" width="800">
    <div class="titlebar">Bestanden</div>
    <table>
      <tr
        v-for="file in slice(
          logs,
          logsPage * logsResultsPerPage,
          (logsPage + 1) * logsResultsPerPage)"
          :key="file.id"
        >
        <td style="white-space:nowrap;">{{toTextDate(file)}}</td>
        <td style="word-break:break-all;">{{file.path}}</td>
        <td class="number">
          <a
            @click="download(file.path)"
            class="secondary"
          ><awesomeIcon icon="download"/><span class="download-txt"> Download</span>
          </a>
        </td>
        <td class="number">
          <a
            @click="deleteFile(file.path)"
            class="secondary"
          ><awesomeIcon icon="trash"/><span class="download-txt"> Delete</span>
          </a>
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <div class="pagebar">
            <button v-if="logsPage !== 0" @click="logsPage -= 1" title="Vorige pagina">
              <awesomeIcon icon="chevron-left"/>
            </button>
            <span class="pagination">Pag. {{ logsPage + 1 }}</span>
            <button
              v-if="slice(
                logs,
                (logsPage + 1) * logsResultsPerPage,
                (logsPage + 2) * logsResultsPerPage).length > 0"
              @click="logsPage += 1"
              title="Volgende pagina"
            >
              <awesomeIcon icon="chevron-right"/>
            </button>
          </div>
        </td>
      </tr>
    </table>
  </modalWindow>
</template>

<script>
import { slice } from 'lodash-es';

export default {
  name: 'UserFiles',
  data() {
    return {
      user: null,
      logging: false,
      logs: [],
      logsPage: 0,
      logsResultsPerPage: 12,
    };
  },
  methods: {
    slice,
    toTextDate(file) {
      return new Date(parseInt(file.path.slice(7, 20), 10)).toLocaleDateString();
    },
    userFiles(user) {
      this.logs = [];
      this.logsPage = 0;
      this.logging = true;
      this.user = user;
      this.sdk.getUserFiles(user, (response) => {
        this.logs = response.data;
      });
    },
    download(file) {
      this.sdk.getUserFile(this.user, file);
    },
    deleteFile(file) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u dit bestand wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteUserFile(this.user, file, () => this.userFiles(this.user));
          }
        },
      });
    },
  },
};
</script>
